/*
  单个老师的数据内容
*/

export default {
  state: {
    id: null,
    avatar: undefined,
    name: '',
    title: ''
  },
  mutations: {
    UPDATE_TEACHER (state, teacher) {
      ['id', 'avatar', 'name', 'title'].forEach(key => {
        state[key] = teacher[key]
      })
    }
  },
  actions: {
    updateTeacher ({ commit }, teacher) {
      commit('UPDATE_TEACHER', teacher)
    }
  }
}
